import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

//全局变量
const state = {
  //用户视频全局变量
  userInfo: {},   //当前登陆用户的信息
  roleList:[],   //角色集合
  permList:[],   //权限集合

  onLoad:false,//加载中
  audioing:false,//呼叫声音

  nim: {},        //云信
  netcall:{},
  Netcall:'',
  applyList: [],  //用户申请
  sessionList: [],//会话用户列表
  friendList: [], //通讯录列表
  chatList: [],   //聊天列表 [包括离线消息，漫游聊天]
  newestData: {}, //最新数据
  sysMsgUnread: 0, //系统通知未读数
  sysMsgs: [], //系统消息列表
  beCalledInfo:{},//被呼叫时 呼叫者信息
  showVideo:false,//视频通话显示视频画面
  calling:false,//视频呼叫通知变量
  toCall:false,//呼叫他人视频变量
  callTimer:{},//呼叫计时器
  callTime:'',//通话时长
  video:false,//视频信息
  called:false,//呼叫被拒绝

  remind:false,//准备会诊提示

  consult:false,//视频接听，刷新问诊室列表
  

  systemPhy:false,//发起问诊页面推送
  systemCon:false,//收到会诊页面推送
  systemPhy:false,//发送问诊推送
  systemCon:false,//收到会诊推送


  //其他全局变量
  breadList:[],//面包屑路径

  addRouter:0,//动态路由标记
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js